export default "__VITE_ASSET__BaZyMccv__"